module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-mobile-9748218917204d57a2f5c79f47110234.jpg";